import React, {useState, useEffect} from 'react'
import { Image, Container } from 'react-bootstrap'
import b11 from "../../../../assets/notarymeet/b11.png"
import b1111 from "../../../../assets/notarymeet/b1111.png"

import '../notarymeet.css'


function B11() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#343434",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
        {isSmallScreen ? (
          <Image src={b1111} alt='b1111' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        ) : (
          <Image src={b11} alt='b11' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
        )}
       
    </Container>
    
     
    
  )
}

export default B11
